import { useEffect} from "react";

function SingupConfirm() {
useEffect(()=>{
    setTimeout(() => {
        window.location.replace('https://staging.athenafintech.com/', '_blank');
    }, 6000);
},[])

  return (
    <>
      <div className="container-fluid pt-8">
        <div className="cardsucess bodysucess justify-content-center">
          <div className="divsucess" style={{ height: '100px', width: '100px' }}>
            <i className="checkmark isucess" style={{ lineHeight: '100px', fontSize: '50px', marginLeft: '-7px' }}>✓</i>
          </div>

          <p className="psucess">Thank you for Register. You're registered successfully. 
                Please check your email for login instructions.</p><br />
        </div>
      </div>
    </>
  );
}

export default SingupConfirm;